import * as yup from "yup";
import _ from "lodash";

export function label(value, text) {
  let placeholder, label;

  if (!value) {
    placeholder = text;
  } else {
    label = text;
  }

  return {
    placeholder,
    label
  };
}

export function sliceByWord(text, maximum) {
  let accumulatedTotal = 0;

  const parts = [];
  for (const t of text.split(" ")) {
    let newTotal = accumulatedTotal + t.length;
    if (newTotal < maximum) {
      accumulatedTotal += t.length;
      parts.push(t);
    } else {
      break;
    }
  }

  return parts.join(" ");
}

function buildRule(fn) {
  let schema = yup.string();

  if (fn) {
    schema = fn(schema);
  }

  return v => {
    try {
      schema.validateSync(v);
      return true;
    } catch (e) {
      if (e.name === "ValidationError" && e.errors) {
        return e.errors[0];
      }
    }
  };
}

const rulesFunctions = {
  required: () => buildRule(schema => schema.required("Field is required.")),

  phoneNumber: () =>
    buildRule(schema =>
      schema.required("Phone Number is required.").matches(
        // /^\(\d{3}\) \d{3}-\d{4}$/,
        /^(?:(?:(?:\+?1\s*(?:[.-]?\s*)?)?\(?(?:(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]‌​)\s*)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\)?\s*(?:[.-]?\s*)?)([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]?\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?)?$/,
        "Phone Number is not in a valid format."
      )
    ),

  email: () =>
    buildRule(schema =>
      schema.required("Email is required.").email("Invalid email address.")
    ),

  zipCodeUs: () =>
    buildRule(schema =>
      schema.matches(/^[0-9]{5}$/, "Invalid Zip Code format")
    ),

  zipCodeCa: () =>
    buildRule(schema =>
      schema.matches(
        /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
        "Invalid Zip Code format"
      )
    ),

  min: min => buildRule(schema => schema.min(min))
};

export function getRuleValidators(rules) {
  rules = rules.map(rule => {
    let name = rule;
    let params = [];

    if (_.isArray(rule)) {
      const ruleArr = [...rule];

      name = ruleArr.shift();
      params = ruleArr;
    }

    if (!_.isString(name)) {
      throw new Error(`rule name ${rule} needs to be a string`);
    }

    if (!rulesFunctions[name]) {
      throw new Error(`rule ${name} is not supported`);
    }

    return rulesFunctions[name](...params);
  });

  return rules;
}
